<template>
  <div>
    <h4>Login you out... if the browser don't redirect you, click on login</h4>
  </div>
</template>

<script>

  export default {
    data(){
      return {
        email : "",
        password : ""
      }
    },
    methods : {
    },
    mounted: function() {
      localStorage.removeItem('user');
      localStorage.removeItem('jwt');
      this.$router.push({name: "Login"});
    }
  }
</script>

<style>

</style>
